import { GENERAL_ERRAND_ACTIVE_STATUSES } from '@/app/dashboard/technical-management/constants';
import { DateTime } from 'luxon';

/** An errand counts as "förfaller snart" this many hours before its required done time. */
export const GENERAL_ERRAND_EXPIRES_SOON_HOURS = 24;

type ExpirableGeneralErrand = {
  status?: number | null;
  requiredDoneTime?: string | null;
};

/**
 * Hours left until the errand expires, or null if it can't expire (no required
 * done time, or the errand is no longer active).
 */
function getHoursUntilExpiration(errand: ExpirableGeneralErrand) {
  if (errand.status == null || !errand.requiredDoneTime) {
    return null;
  }
  if (!GENERAL_ERRAND_ACTIVE_STATUSES.includes(errand.status)) {
    return null;
  }
  return DateTime.fromISO(errand.requiredDoneTime).diffNow('hours').hours;
}

export function getIsGeneralErrandExpired(errand: ExpirableGeneralErrand) {
  const hours = getHoursUntilExpiration(errand);
  return hours !== null && hours <= 0;
}

export function getGeneralErrandExpiresSoon(errand: ExpirableGeneralErrand) {
  const hours = getHoursUntilExpiration(errand);
  return (
    hours !== null && hours > 0 && hours <= GENERAL_ERRAND_EXPIRES_SOON_HOURS
  );
}
